import {MatTooltipDefaultOptions} from "@angular/material/tooltip";

export const tooltipDefaults: MatTooltipDefaultOptions = {
    showDelay: 0,
    hideDelay: 0,
    touchendHideDelay: 0,
    touchGestures: "off",
    position: "left"
};
